import { useThree } from '@react-three/fiber';
import { useEffect } from 'react';
import { useDataStore, useSceneStore } from '../zustand';
import { isAbstractComponent } from './r3f-components/utils/general';

const VisibilityController = () => {
	const componentsById = useDataStore(({ componentsById }) => componentsById);
	const activeSceneId = useSceneStore(({ activeSceneId }) => activeSceneId);
	const { scene } = useThree();

	useEffect(() => {
		if (!componentsById) return;

		// Hide any entities that were hidden in Designer
		Object.entries(componentsById).forEach(([id, component]) => {
			if (isAbstractComponent(component)) return;
			const prospectiveGroupId = `toggleVisibilityGroup-${id}`;
			const threeGroup = scene.getObjectByName(prospectiveGroupId);
			if (threeGroup) {
				threeGroup.visible = !component.isHidden;
			}
		});
	}, [componentsById, activeSceneId]);

	return null;
};

export default VisibilityController;
